import InventoryIcon from '@mui/icons-material/Inventory';
import LayersIcon from '@mui/icons-material/Layers';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { IconButton, Tooltip } from '@mui/material';
import { NavLink } from 'react-router-dom';

import type { CSSProperties } from 'react';

const activeStyle = ({ isActive }: { isActive: boolean }) => ({
  color: isActive ? '#84C340' : 'inherit',
});

const TopMenu = () => {
  return (
    <>
      <Tooltip title="Escaneo">
        <IconButton
          size="large"
          component={NavLink}
          to="/inventory/reception"
          color="inherit"
          style={activeStyle as unknown as CSSProperties}
        >
          <InventoryIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Consulta de series">
        <IconButton
          size="large"
          component={NavLink}
          to="/izzi/series"
          color="inherit"
          style={activeStyle as unknown as CSSProperties}
        >
          <LayersIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Órdenes de venta Izzi">
        <IconButton
          size="large"
          component={NavLink}
          to="/izzi/orders"
          color="inherit"
          style={activeStyle as unknown as CSSProperties}
        >
          <LocalShippingIcon />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default TopMenu;
